import { createPatchEndpoint } from '@sonar-software/sonar-http';

export type PatchCurrentUserRequest = {
	firstName?: string;
	lastName?: string;
	userId: number;
};

export const patchCurrentUser = createPatchEndpoint<PatchCurrentUserRequest>(
	'/api/v3/core/users/current',
	{
		requestTransform: ({ userId, ...rest }) => rest
	}
);
